import { useNavigate } from "react-router-dom";
import { User, Wrench, ShieldCheck, Droplets } from "lucide-react";
import { Btn } from "../components/kit";

const roles = [
  { to: "/customer", label: "Cool Car Customer", desc: "Register, pick a service, pay & track your wash", icon: User, color: "from-cyan-500/20" },
  { to: "/crew", label: "Cool Car Crew", desc: "Queue, bays, service timers & payments", icon: Wrench, color: "from-blue-500/20" },
  { to: "/admin", label: "Cool Car Admin", desc: "Sales, live ops, pricing, cash & reports", icon: ShieldCheck, color: "from-emerald-500/20" },
];

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="max-w-md mx-auto min-h-screen px-5 pt-14 pb-28 animate-in">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-12 h-12 rounded-2xl bg-cyan-500 flex items-center justify-center shadow-[0_0_25px_rgba(0,210,254,0.5)]">
          <Droplets className="text-slate-950" size={26} strokeWidth={2.6} />
        </div>
        <div>
          <h1 className="font-head text-2xl font-extrabold tracking-tight leading-none">Cool Car Centrale</h1>
          <p className="text-xs text-cyan-400/90 font-semibold tracking-widest uppercase mt-1">Real-Time Operations</p>
        </div>
      </div>
      <p className="text-slate-400 text-sm mt-4 mb-8 leading-relaxed">
        One connected system for your carwash — from customer check-in to bay operations to owner reporting. Pick an interface to begin.
      </p>

      <div className="space-y-4">
        {roles.map(({ to, label, desc, icon: Icon, color }) => (
          <button key={to} data-testid={`landing-${to.slice(1)}`} onClick={() => nav(to)}
            className={`w-full text-left bg-gradient-to-br ${color} to-[#1C2541] border border-cyan-500/20 rounded-2xl p-5 flex items-center gap-4 hover:border-cyan-400/50 transition-all active:scale-[0.98]`}>
            <div className="w-12 h-12 rounded-xl bg-[#0B132B] border border-cyan-500/30 flex items-center justify-center shrink-0">
              <Icon className="text-cyan-400" size={24} />
            </div>
            <div>
              <div className="font-head font-bold text-lg leading-tight">{label}</div>
              <div className="text-xs text-slate-400 mt-0.5">{desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
